export type CampaignStatus = "Active" | "Completed" | "Draft" | "Scheduled";
export type CampaignChannel = "WhatsApp" | "SMS" | "Email";

export interface Campaign {
  id: string;
  name: string;
  type: CampaignChannel;
  status: CampaignStatus;
  leads: number;
  sent: number;
  openRate: number | null;
  created: string;
}

export const campaignsData: Campaign[] = [
  { id: "camp-1", name: "Site Visit Invitation — June", type: "WhatsApp", status: "Active", leads: 156, sent: 156, openRate: 42.3, created: "15 Jun" },
  { id: "camp-2", name: "Property Launch — Bandra West", type: "WhatsApp", status: "Completed", leads: 312, sent: 312, openRate: 38.1, created: "10 Jun" },
  { id: "camp-3", name: "Follow-up — Cold Leads", type: "WhatsApp", status: "Completed", leads: 89, sent: 89, openRate: 18.4, created: "05 Jun" },
  { id: "camp-4", name: "New Project Announcement", type: "WhatsApp", status: "Draft", leads: 0, sent: 0, openRate: null, created: "20 Jun" },
  { id: "camp-5", name: "Price Drop Alert", type: "WhatsApp", status: "Scheduled", leads: 234, sent: 0, openRate: null, created: "25 Jun" },
  { id: "camp-6", name: "Festive Offer — Ganpati", type: "WhatsApp", status: "Draft", leads: 0, sent: 0, openRate: null, created: "28 Jun" },
  { id: "camp-7", name: "Site Visit Done — Next Steps", type: "WhatsApp", status: "Completed", leads: 67, sent: 67, openRate: 51.2, created: "01 Jun" },
  { id: "camp-8", name: "Loan Assistance Available", type: "WhatsApp", status: "Completed", leads: 123, sent: 123, openRate: 29.7, created: "28 May" },
];

export function getCampaignStatusBadge(status: CampaignStatus): string {
  const map: Record<CampaignStatus, string> = {
    Active: "bg-green-50 text-green-700",
    Completed: "bg-gray-100 text-gray-600",
    Draft: "bg-amber-50 text-amber-700",
    Scheduled: "bg-blue-50 text-blue-700",
  };
  return map[status] || "bg-gray-100 text-gray-600";
}

export const campaignTemplates = [
  {
    id: "tpl-1",
    name: "Initial Greeting",
    status: "Approved",
    language: "English",
    body: "Hi {lead_name}! 👋\nThank you for your inquiry.\nAre you still looking for {property_type}?\n\nReply with:\n*1* - Yes, still interested\n*2* - Not looking anymore\n*3* - Please call me",
    variables: ["{lead_name}", "{property_type}"],
  },
  {
    id: "tpl-2",
    name: "24hr Follow-up",
    status: "Approved",
    language: "English",
    body: "Hi {lead_name}, this is {agent_name} from {company}.\n\nWe noticed you haven't responded to our earlier message.\n\nAre you still interested? We have some exciting options that match your requirements! 🏠",
    variables: ["{lead_name}", "{agent_name}", "{company}"],
  },
  {
    id: "tpl-3",
    name: "Site Visit Invitation",
    status: "Approved",
    language: "English",
    body: "Hi {lead_name}! 🏗️\n\nWe'd love to invite you for a site visit at {property_name}.\n\n📅 Available slots:\n• {date} at {time}\n\nWould you like to book a slot? Reply *YES* to confirm!",
    variables: ["{lead_name}", "{property_name}", "{date}", "{time}"],
  },
  {
    id: "tpl-4",
    name: "Price Update",
    status: "Approved",
    language: "English",
    body: "Hi {lead_name},\n\nGreat news! The price for {property_name} has been updated.\n\n💰 New price: {price}\n\nLimited inventory available. Would you like to know more?",
    variables: ["{lead_name}", "{property_name}", "{price}"],
  },
];

export const savedSegments = [
  { id: "seg-1", name: "Hot Leads — Mumbai", count: 89, description: "Score 80+ in Mumbai region" },
  { id: "seg-2", name: "Site Visit Done — No Proposal", count: 34, description: "Visited site but no proposal sent yet" },
  { id: "seg-3", name: "Cold Leads — Inactive 30 days", count: 156, description: "No activity for 30+ days" },
];

export const campaignStats = {
  total: 8,
  active: 2,
  leadsReached: 1247,
  avgOpenRate: 34.2,
};